import React from "react";
import './Footer.css';
import { FaFacebookF,FaGithub,FaTwitter,FaLinkedin } from "react-icons/fa";

export const Footer = () => {
  return (
    <div>
      <footer class="footer">
        
        <div class="container">
            <div class="row">
                <div class="footer-col">
                    <h4>Contact Us</h4>
                    <ul>
                        <li><a href="#">About Us</a></li>
                        <li><a href="#">Phone</a></li>
                        <li><a href="#">Mail</a></li>
                    </ul>
                </div>
                <div class="footer-col">
                    <h4>Get help</h4>
                    <ul>
                        <li><a href="#">FAQ</a></li>
                    </ul>
                </div>
                <div class="footer-col">
                    <h4>Follow Us</h4>
                    <div class="social-links">
                        <a href="#"><FaFacebookF /></a>
                        <a href="#"><FaGithub /></a>
                        <a href="#"><FaTwitter /></a>
                        <a href="#"><FaLinkedin /></a>

                    </div>
                </div>
            </div>
            <footer class="background">
		<p class="text-footer">
			Copyright ©-All rights are reserved
		</p>
	</footer>
        </div>

    </footer>
    </div>
  )
}

export default Footer;